module.exports = __webpack_public_path__ + "media/assets/images/category/Hanukkah@2x-7a71633ba2ee2320d96c73544b3580c8.png";